import Base from '../common/Base';
import './index.scss';

// 自下划入动画组件
function SlideUp(props) {
  return (<Base classNames="slide-up" {...props}></Base>);
}

export default SlideUp;